import React from 'react';
import ChiliPiperComponent from 'Components/ComponentLibrary/Molecules/ChiliPiperComponent/ChiliPiperComponent';
import Content from 'Views/Page/Content/Templates/ManualRolloverTemplate/content';
import { metaOverrideSet } from 'Views/Page/Content/Templates/CapitalizeRolloverIntroStepTemplate/metaOverride';
import fr from 'facet-rest';
import useManualRolloverContext from 'Views/Page/Content/Templates/ManualRolloverTemplate/ManualRolloverContext';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import StepNavigator from 'Components/ComponentLibrary/Molecules/StepNavigator';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  FDStack, Stack,
} from '@facet-wealth/design';
import Box from '../../../../../Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const useStyles = makeStyles(theme => ({
  stepNavigator: {
    position: 'sticky',
    zIndex: 100,
    bottom: 0,
  },
  form: {
    flexGrow: 1,
    backgroundColor: theme.palette.facet.lightGray,
  },
}));


const ManualRolloverTemplate = () => {
  const classes = useStyles();
  const { loadPageContentLink } = usePageContentContext();
  const {
    onStepSubmit, canSubmit, chiliPiperRel, showChiliPiperComponent, manualRolloverResource, loading, onScheduleChiliPiperForNonAcats, handleChiliPiperExit,
  } = useManualRolloverContext();

  const handleBack = async () => {
    manualRolloverResource.withRelationship(fr.relationships.previousLink.name,
      () => {
        loadPageContentLink(manualRolloverResource.relationship(fr.relationships.previousLink.name).link('related'));
      },
      () => null);
  };

  const handlePrimaryNext = async () => {
    await onStepSubmit();
  };

  const handleSecondaryNext = async () => {
    await onScheduleChiliPiperForNonAcats();
  };

  return (
    (showChiliPiperComponent ? (
      <ChiliPiperComponent rel={chiliPiperRel} handleChiliPiperExit={handleChiliPiperExit} />
    ) : (
      <Stack direction={'column'} minHeight={'100dvh'}>
        <MetaFormInline
          className={classes.form}
          noIndividualSubmitButtons
          resource={manualRolloverResource}
          layout={Content}
          LayoutProps={{
            resource: manualRolloverResource,
            canSubmit,
            handleSecondaryNext,
          }}
          metaOverrideSet={metaOverrideSet}
        />
        <Box className={classes.stepNavigator}>
          <FDStack direction={'column'} alignItems={'center'}>
            <StepNavigator
              onNext={canSubmit && handlePrimaryNext}
              isLoading={loading}
              disabled={loading}
              onPrevious={handleBack}
            >
              {manualRolloverResource.attr('primaryActionLabel') || 'Continue'}
            </StepNavigator>
          </FDStack>
        </Box>
      </Stack>
    )));
};

ManualRolloverTemplate.defaultProps = {
};

ManualRolloverTemplate.propTypes = {
};

export default ManualRolloverTemplate;
